import React from "react";

import { FormControl, FormLabel, Grid, TextField } from "@mui/material";

interface ActionLoaderFormProps {
  actionTitles: string[];
  setActionTitles: (newActionsTitle: string[]) => void;
  actionsCount: number;
  setActionsCount: (newActionsCount: number) => void;
}

const ActionLoaderForm = ({
  actionTitles,
  setActionTitles,
  actionsCount,
  setActionsCount,
}: ActionLoaderFormProps) => {
  return (
    <FormControl fullWidth>
      <Grid container direction="row" alignItems="center" paddingTop={1}>
        <Grid item xs={6}>
          <FormLabel required>Actions Title</FormLabel>
          <br></br>
          <FormLabel>Ex: Actions Title 1, Actions Title 2 ...</FormLabel>
        </Grid>
        <Grid item xs={6}>
          <TextField
            name="action-titles-input"
            placeholder="Input actions titles"
            inputProps={{
              "data-testid": "action-titles-input",
            }}
            multiline
            fullWidth
            margin="normal"
            variant="outlined"
            onChange={(e) => {
              if (e.target.value.trim() === "") {
                setActionTitles([]);
                return;
              }
              setActionTitles(e.target.value.split(","));
            }}
            value={actionTitles}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" alignItems="center" paddingTop={1}>
        <Grid item xs={6}>
          <FormLabel required>Number of Actions to create</FormLabel>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <TextField
            id="actions-count-input"
            value={actionsCount.toString()}
            fullWidth
            type="number"
            onChange={(e) => {
              let count = parseInt(e.target.value);
              if (count > 1000) {
                count = 1000;
              }
              if (Number.isNaN(count) || count < 0) {
                count = 0;
              }
              setActionsCount(count);
            }}
            margin="normal"
            variant="outlined"
            InputProps={{
              inputProps: {
                "data-testid": "actions-count-input",
              },
            }}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default ActionLoaderForm;
